import { DatePicker } from '@mui/lab';
import { Divider, Grid } from '@mui/material';
import { useFormikContext } from 'formik';
import { LotsManagementNewVM } from 'front-office/view-models/lots-management/new';
import { ReactElement } from 'react';
import { PmiTitleDivider } from 'shell/components/shared/pmi-title-divider';
import PmiTextField from 'shell/components/shared/text-field';
import Services from 'shell/components/shared/list-service';
import OperatorList from 'front-office/components/shared/operator-list';

const FormNew = (): ReactElement => {
  const formContext = useFormikContext<LotsManagementNewVM>();

  return (
    <Grid container spacing={2}>
      <Grid item xs={12}>
        <PmiTitleDivider>{"Lotto di carte d'identità"}</PmiTitleDivider>
      </Grid>
      <Grid item xs={12}>
        <Divider />
      </Grid>
      <Grid item xs={12} md={5}>
        <PmiTextField
          aria-label="Da numero"
          label="Da numero"
          id="fromNumber"
          name="fromNumber"
          fullWidth
          type="text"
          variant="outlined"
          value={formContext.values.fromNumber || ''}
          onChange={(event) => formContext.setFieldValue('fromNumber', event.target.value || '')}
          error={formContext.touched.fromNumber && Boolean(formContext.errors.fromNumber)}
          helperText={formContext.errors.fromNumber}
          inputProps={{
            maxLength: '9',
          }}
        />
      </Grid>
      <Grid item xs={12} md={5}>
        <PmiTextField
          aria-label="A numero"
          label="A numero"
          id="toNumber"
          name="toNumber"
          fullWidth
          type="text"
          variant="outlined"
          value={formContext.values.toNumber || ''}
          onChange={(event) => formContext.setFieldValue('toNumber', event.target.value || '')}
          error={formContext.touched.toNumber && Boolean(formContext.errors.toNumber)}
          helperText={formContext.errors.toNumber}
          inputProps={{
            maxLength: '9',
          }}
        />
      </Grid>
      <Grid item xs={12}>
        <PmiTitleDivider>Viene assegnato a</PmiTitleDivider>
      </Grid>
      <Grid item xs={12}>
        <Divider />
      </Grid>
      <Grid item xs={12} md={4}>
        <Services
          value={formContext.values.service || ''}
          onChange={(event) => formContext.setFieldValue('service', event.target.value || '')}
          label="Servizio"
          fgCashManagement="S"
        />
      </Grid>
      <Grid item xs={12} md={4}>
        <OperatorList
          allOperator={false}
          idService={formContext.values.service === 'TUTTI' ? '' : formContext.values.service || ''}
          value={formContext.values.operator || ''}
          onChange={(value) => formContext.setFieldValue('operator', value || '')}
          disabled={!Boolean(formContext.values.service)}
        />
      </Grid>
      <Grid item xs={12} md={4}>
        <DatePicker
          label="In data"
          aria-label="In data"
          value={formContext.values.date || null}
          onChange={(date) => {
            formContext.setFieldValue('date', date || null);
          }}
          renderInput={(params) => <PmiTextField id="date" {...params} fullWidth helperText="" />}
        />
      </Grid>
    </Grid>
  );
};

FormNew.displayName = 'Lots Management New - Form Page component';

export default FormNew;
